import { render, staticRenderFns } from "./DeptManage.vue?vue&type=template&id=69c0346f&scoped=true"
import script from "./DeptManage.vue?vue&type=script&lang=js"
export * from "./DeptManage.vue?vue&type=script&lang=js"
import style0 from "./DeptManage.vue?vue&type=style&index=0&id=69c0346f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c0346f",
  null
  
)

export default component.exports